import { render, staticRenderFns } from "./l28-udid.vue?vue&type=template&id=e85185b6&"
import script from "./l28-udid.vue?vue&type=script&lang=js&"
export * from "./l28-udid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports